import React, { useState } from "react";
import DateRange from "../dashboard/DateRange";
import { httpRequestGet, toaster } from "../../utils/utils";
import { useDispatch } from "react-redux";
import apiConstants from "../../constans/apiConstants";
import { Accordion, Card } from "react-bootstrap";
import ExportExcel from "../../components/Table/ExportExcel";

const CibilReports = ({ embedded = false }) => {
  const [data, setData] = useState([]);
  const dispatch = useDispatch();

  const applyDateRange = (startDate, endDate) => {
    const path = `${apiConstants().BAXA_API_URL}cibil/data?${"fromDate=" + startDate + "&toDate=" + endDate}`;
    dispatch({ type: "LOADER_TRUE" });
    httpRequestGet(path)
      .then((res) => {
        dispatch({ type: "LOADER_FALSE" });
        if (res && res.data) {
          setData(res.data.body || []);
          toaster("success", res.data.message);
        }
      })
      .catch((err) => {
        dispatch({ type: "LOADER_FALSE" });
        if (err && err.data) {
          toaster("error", err.data.message);
        }
      });
  };

  const content = (
    <>
      {embedded && (
        <h3 className="reports-tab-panel__title">Cibil Details</h3>
      )}

      <div className="date-range">
        <DateRange applyDateRange={applyDateRange} />
      </div>

      {data.length > 0 && (
        <>
          <div className="excel-download">
            <ExportExcel
              cellHeaders={["Proposal Number"]}
              data={data}
              keys={["proposalNo"]}
              fileName="cibil report"
            />
          </div>

          <div className="cibil_comp cibil-report-page__results">
            <Accordion flush>
              {data.map((item, index) => (
                <Card key={item.proposalNo || index}>
                  <Accordion.Toggle as={Card.Header} eventKey={String(index + 1)}>
                    {item.proposalNo}
                  </Accordion.Toggle>

                  <Accordion.Collapse eventKey={String(index + 1)}>
                    <div>
                      <pre>{JSON.stringify(item, null, 2)}</pre>
                    </div>
                  </Accordion.Collapse>
                </Card>
              ))}
            </Accordion>
          </div>
        </>
      )}
    </>
  );

  if (embedded) {
    return <div className="reports-tab-panel">{content}</div>;
  }

  return (
    <div className="proposal-dashboard cibil-report-page">
      <div className="proposal-dashboard__header cibil-report-page__header">
        <h2 className="proposal-dashboard__title">Cibil Reports</h2>
        <p className="proposal-dashboard__subtitle">
          View CIBIL report details by proposal for the selected date range
        </p>
      </div>

      <div className="reports-page__content">{content}</div>
    </div>
  );
};

export default CibilReports;
